import { render, staticRenderFns } from "./DenseMode.vue?vue&type=template&id=2329d3cd&"
import script from "./DenseMode.vue?vue&type=script&lang=js&"
export * from "./DenseMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports